export const createRequestLoadingSelector = (requestNames) => (state) => {
  return requestNames.some((requestName) => state.request[requestName]);
};
